// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"cedd9b7f","732":"c7b536f1","977":"7e2ba998"}[chunkId] + ".chunk.js";
};